module.exports = __webpack_public_path__ + "static/img/about.854ce9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about.jpg
// module id = UAsQ
// module chunks = 0